import * as React from 'react';
import i18next from 'i18next';
import { serverUrl } from "../_constants";
import Dropzone from "react-dropzone";
import classNames from "classnames";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function DropFile(props) {
  const size = props.size ?? 250;
  const isFill = size === "fill";
  return (<div className="file" style={isFill ? { height: "100%" } : undefined}>
    <Dropzone
      onDrop={props.onDrop}
      class="visually--hidden"
    >
      {({
        getRootProps,
        getInputProps,
        isDragActive,
      }) => {
        return (
          <div
            style={{
              textAlign: "center",
              position: "relative",
              width: isFill ? "100%" : size,
              height: isFill ? "100%" : size,
              minHeight: isFill ? 250 : undefined,
              background: "#eee",
              borderRadius: 5,
            }}
            {...getRootProps()}
            className={classNames("dropzone", {
              "dropzone--isActive": isDragActive,
            })}
          >
            <input {...getInputProps()} />

            {props.image && (
              <img
                src={(props.image.startsWith("blob") ? "" : serverUrl) + props.image}
                alt=""
                class="object-cover"
              />
            )}
            {/* Центрируем надпись флексом, а не парой left/right с transform:
                при таком расчёте её подложка вылезала за правый край рамки
                (пункт 75 QA-таблицы). Обёртка накрывает рамку целиком, отступы
                держат подложку внутри, клики проходят сквозь неё на dropzone. */}
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 15,
                boxSizing: "border-box",
                pointerEvents: "none",
              }}
            >
              <p
                style={{
                  fontSize: 12,
                  background: "#eee",
                  padding: 10,
                  borderRadius: 5,
                  margin: 0,
                  maxWidth: "100%",
                }}
              >
                {i18next.t(isDragActive ? "dropzone_file_upload" : "dropzone_title_hint")}
              </p>
            </div>

            {props.loading && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgba(255, 255, 255, 0.6)",
                  borderRadius: 5,
                  pointerEvents: "none",
                }}
              >
                <CircularProgress />
              </div>
            )}
          </div>
        );
      }}
    </Dropzone>
  </div>);
}
